// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605130505/js/" + chunkId + "." + {"44":"0b1f80af","225":"8691eee8","481":"5c35b3df","486":"043a71a7","770":"fc0c3796"}[chunkId] + ".0.23121568772763568.chunk.js";
};